import api from './api';

export const albumApi = {
  getAllAlbums: async (sortBy = 'popular') => {
    const response = await api.getPublic(`/albums?sortBy=${sortBy}`);
    return response.data;
  },

  // 앨범 상세 조회
  getAlbumById: async (id) => {
    const response = await api.getPublic(`/albums/${id}`);
    return response.data;
  },

  // 슬러그로 앨범 상세 조회 (sourceId/sourceType은 slug가 DB에 없을 때 폴백용)
  getAlbumBySlug: async (slug, { sourceId, sourceType, backgroundTracks = false } = {}) => {
    const query = new URLSearchParams();
    if (sourceId) {
      query.set('sourceId', sourceId);
      query.set('sourceType', sourceType ?? 'APPLE_MUSIC');
    }
    if (backgroundTracks) query.set('trackRefresh', 'background');
    const params = query.toString() ? `?${query}` : '';
    const response = await api.getAuth(`/albums/by-slug/${slug}${params}`);
    return response.data;
  },

  // 앨범 수정
  updateAlbum: async (sourceId, albumSource, data) => {
    const response = await api.putAuth(`/albums?id=${sourceId}&type=${albumSource}`, data);
    return response.data;
  },

  // 앨범 검색
  searchAlbums: async (query) => {
    const response = await api.getPublic(`/search/albums?q=${query}`);
    return response.data;
  },

  // 트랙 검색
  searchTracks: async (query) => {
    const response = await api.getPublic(`/search/tracks?q=${query}`);
    return response.data;
  },

  // 앨범 댓글 추가
  addComment: async (albumId, content) => {
    const response = await api.postAuth(`/albums/${albumId}/comments`, { content });
    return response.data;
  },

  // 앨범 댓글 삭제
  deleteComment: async (albumId, commentId) => {
    const response = await api.deleteAuth(`/albums/${albumId}/comments/${commentId}`);
    return response.data;
  },

  // 앨범 생성
  createAlbum: async (sourceId, albumSource = 'APPLE_MUSIC', displayRegion) => {
    const formData = {
      sourceId: sourceId,
      albumSource: albumSource,
    };
    if (displayRegion) {
      formData.displayRegion = displayRegion;
    }
    const response = await api.postAuth(`/albums/new-releases`, formData);
    return response.data;
  },

  // 크리틱 리뷰 목록 조회
  getCriticReviews: async (albumId) => {
    const response = await api.getPublic(`/albums/${albumId}/critic-reviews`);
    return response.data;
  },

  // 크리틱 리뷰 삭제
  deleteCriticReview: async (reviewId) => {
    const response = await api.deleteAuth(`/albums/critic-reviews/${reviewId}`);
    return response.data;
  },

  // 크리틱 리뷰 수정
  updateCriticReview: async (reviewId, data) => {
    const response = await api.putAuth(`/albums/critic-reviews/${reviewId}`, data);
    return response.data;
  },

  // 크리틱 리뷰 생성
  createCriticReview: async (sourceId, albumSource, data) => {
    const response = await api.postAuth(
      `/albums/critic-reviews?id=${sourceId}&type=${albumSource}`,
      data,
    );
    return response.data;
  },

  getOtherVersions: async (sourceId, albumSource) => {
    const type = albumSource === 'LOCAL' ? 'local' : albumSource.toLowerCase();
    const response = await api.getPublic(`/albums/other-versions?type=${type}&id=${sourceId}`);
    return response.data;
  },

  getRelatedAlbums: async (sourceId, albumSource) => {
    const type = albumSource === 'LOCAL' ? 'local' : albumSource.toLowerCase();
    const response = await api.getPublic(`/albums/related?type=${type}&id=${sourceId}`);
    return response.data;
  },

  createRecommendAlbum: async (
    sourceId,
    albumSource = 'APPLE_MUSIC',
    recommendationComment,
    recommendationCommentEn,
  ) => {
    const formData = {
      sourceId: sourceId,
      albumSource: albumSource,
      recommendationComment,
      recommendationCommentEn,
    };
    const response = await api.postAuth(`/albums/recommend`, formData);
    return response.data;
  },

  addHomeLatestAlbum: async (albumId) => {
    const response = await api.postAuth('/albums/home-feature/latest', { albumId });
    return response.data;
  },

  addHomeLatestAlbumBySource: async (sourceId, albumSource = 'APPLE_MUSIC') => {
    const response = await api.postAuth('/albums/home-feature/latest/source', {
      sourceId,
      albumSource,
    });
    return response.data;
  },

  removeHomeLatestAlbum: async (albumId) => {
    const response = await api.deleteAuth(`/albums/home-feature/latest/${albumId}`);
    return response.data;
  },

  setHomeRecommendedAlbum: async (
    albumId,
    enabled,
    recommendationComment,
    recommendationCommentEn,
  ) => {
    const response = await api.putAuth(`/albums/home-feature/recommended/${albumId}`, {
      enabled,
      recommendationComment,
      recommendationCommentEn,
    });
    return response.data;
  },

  updateLatestAlbumRegion: async (albumId, displayRegion) => {
    const response = await api.putAuth(`/albums/latest-management/${albumId}/region`, {
      displayRegion,
    });
    return response.data;
  },

  hideLatestAlbum: async (albumId) => {
    const response = await api.putAuth(`/albums/latest-management/${albumId}/hide`);
    return response.data;
  },

  removeRecommendedAlbum: async (albumId) => {
    const response = await api.putAuth('/albums/recommend', { ids: [albumId] });
    return response.data;
  },
};
